/* Copyright (c) 2019 Backpack Health LLC */

/* eslint-disable quote-props */
/* global MIXPANEL_TOKEN */

import mixpanel from 'mixpanel-browser';

const TOKEN = MIXPANEL_TOKEN;

const UserMetrics = {
  init() {
    if (!TOKEN) { return; }
    mixpanel.init(TOKEN);
    this.registerPageLevelProperties({
      Channel: 'Group Admin',
    });
  },

  registerPageLevelProperties(superProperties) {
    // superProperties will be included with every subsequent request
    // these would be doing the same thing as doing mixpanel.track(eventName, superProperties) later
    if (!TOKEN) { return; }
    mixpanel.register(superProperties);
  },

  registerAppLevelProperties(superProperties) {
    // these superProperties will only be set, if they are not already set.
    // So this could potentially be called on every page and would only set it if necessary
    if (!TOKEN) { return; }
    mixpanel.register_once(superProperties);
  },

  trackEvent(eventName, eventData) {
    if (!TOKEN) { return; }
    mixpanel.track(eventName, eventData);
  },

  reset() {
    if (!TOKEN) { return; }
    if (mixpanel) {
      mixpanel.reset();
    }
  },
};

export const TrackEvent = {

  dashboard: {
    viewedDashboard() {
      UserMetrics.trackEvent('Viewed Home Page');
    },
  },

};

export default UserMetrics;
